import { gql } from '@apollo/client';

export const ALL_ICT_SKILLS = gql`
  query AllIctSkills {
    ictSkills {
      id
      name
      value
    }
  }
`;
